import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as TickIcon } from '../../../../../assets/images/tickIcon.svg';

import styles from './ImportSuccess.module.scss';

const ImportSuccess = () => {
  const { t } = useTranslation('common');
  return (
    <div className={styles.cont}>
      <p className={styles.heading}>{t('csvImport.processingImport')}</p>
      <div className={styles.infoCont}>
        <div className={styles.tickCont}>
          <TickIcon />
        </div>
        <p className={styles.text}>{t('csvImport.processingInfo')}</p>
      </div>
    </div>
  );
};

export default ImportSuccess;
